import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { postNotifySubscriberContactMethodsOptOut } from "../../../queries/notify";
import { buildNotifyInfiniteSubscriberContactMethodsQueryKey } from "./useInfiniteNotifySubscriberContactMethods";
import { buildNotifySubscriberContactMethodsQueryKey } from "./useNotifySubscriberContactMethodsForLoggedInUser";
import { buildNotifyContactsQueryKey } from "./useInfiniteNotifyContacts";
import { useToasts } from "react-toast-notifications";
import { ToastStatuses } from "../../../components/global_components/Toast";

interface IUseNotifySubscriberContactMethodOptOut {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useNotifySubscriberContactMethodOptOut({ onSuccess }: IUseNotifySubscriberContactMethodOptOut = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();
  const { addToast } = useToasts();

  const [optOutSubscriberContactMethodMutation, { isLoading: isOptOutSubscriberContactMethodLoading }] = useMutation(
    postNotifySubscriberContactMethodsOptOut(networkHeaders),
    {
      onSuccess: async () => {
        if (onSuccess) {
          await onSuccess();
        }

        addToast("Contacts successfully opted out", { appearance: ToastStatuses.Success, autoDismiss: true });

        queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());
        queryCache.invalidateQueries(buildNotifyInfiniteSubscriberContactMethodsQueryKey());
        queryCache.invalidateQueries(buildNotifyContactsQueryKey());
      },
      onError: () => {
        addToast("Failed to opt out contacts", { appearance: ToastStatuses.Error, autoDismiss: true });
      },
    },
  );

  const optOutSubscriberContactMethod = async ({
    subscriberContactMethodIds,
  }: {
    subscriberContactMethodIds: number[];
  }) => {
    return await optOutSubscriberContactMethodMutation({
      subscriberContactMethodIds,
    });
  };

  return { optOutSubscriberContactMethod, isOptOutSubscriberContactMethodLoading };
}
